import { SupportedNetworksData } from '../interface';

const getNetworkDetailsByChainId = (networkData: SupportedNetworksData[], chain: number) => {
  const response = networkData.filter((item: SupportedNetworksData) => item.chainID === chain);

  return response?.[0];
};

export default getNetworkDetailsByChainId;
